import { ModalActionTypes } from "../constants";
import type { Action } from "../actions";

export interface ModalState {
  show: boolean;
}

const DEFAULT_MODAL_STATE: ModalState = {
  show: false,
};

export default function modalReducer(state: ModalState = DEFAULT_MODAL_STATE, action: Action): ModalState {
  if (action.type === ModalActionTypes.SHOW_MODAL) {
    return { ...state, ...action.payload };
  } else if (action.type === ModalActionTypes.HIDE_MODAL) {
    return { ...state, ...DEFAULT_MODAL_STATE };
  } else {
    return state;
  }
}
